import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { IContactsExt } from 'legacy/lut/classes/models/IFormCodeLog'
import { IFormPartners } from 'legacy/lut/classes/models/IFormPartners'
import * as React from 'react'
import { useMemo } from 'react'

import { Table } from 'core-components/library/list'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export interface IProps {
  widgetParams?: IObjectAny
  partners?: IFormPartners[]
  filterPartner?: string
  selectedPartner?: string
  flexWidth?: string
  onClose: any
  contactID: string
}

export const ContactLogDialog = (props: IProps) => {
  const crudSource = useMemo(() => {
    const { contactID } = props
    const source = CrudStore.get(CrudStoreItem.ContactsLog)
    const filter: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [
        {
          field: 'ContactID',
          operator: Operator.EQUAL,
          value: contactID,
        },
      ],
    }
    source.setFilter(filter)
    source.setSort({ field: 'Created', dir: 'desc' })
    return source
  }, [props.contactID])

  const getColumn = useMemo(() => {
    return [
      { field: 'Created', title: 'Created', priority: 1 },
      { field: 'WorkflowStatus', title: 'Workflow Status', priority: 2 },
      {
        field: 'ProfileTeamComment',
        title: 'Profile Team Comment',
        priority: 3,
      },
      { field: 'ModifiedValues', title: 'Modified Values', priority: 4 },
      { field: 'EntryId', title: 'EntryId', priority: 5 },
      { field: 'EntryIdSource', title: 'EntryIdSource', priority: 6 },
      //{ field: 'ActionFrom', title: 'Action From', priority: 7 }, // Not exist in 375
      { field: 'ContactID', title: 'Contact ID', priority: 8 },
      { field: 'FirstName', title: 'First Name', priority: 9 },
      { field: 'LastName', title: 'Last Name', priority: 10 },
      { field: 'PR_HP_ROLE', title: 'Hp Roles', priority: 11 },
      { field: 'CountryOfBusiness', title: 'Country', priority: 12 },
      {
        field: 'MobilePhone_Prefix',
        title: 'Phone country code',
        priority: 13,
      },
      { field: 'MobilePhone', title: 'Phone', priority: 14 },
      {
        field: 'WorkPhone_Prefix',
        title: 'Work phone country code',
        priority: 15,
      },
      { field: 'WorkPhone', title: 'Work phone', priority: 16 },
      { field: 'NeverCall', title: 'Never Call', priority: 17 },
      { field: 'NeverEmail', title: 'Never Email', priority: 18 },
      { field: 'Email', title: 'Email', priority: 19 },
      { field: 'Status', title: 'User Status', priority: 20 },
      { field: 'PartnerID', title: 'Partner ID', priority: 21 },
      { field: 'PreferredLanguage', title: 'Language', priority: 22 },
      { field: 'Seniority', title: 'Seniority', priority: 23 },
      { field: 'Salutation', title: 'Salutation', priority: 24 },
      //
      // Additional fields in 375:
      //
      //CreatedBy?: string
      //App?: string
      //TriggerAction?: string
      //CreatedSource?: string
      //CreatedBySource?: string
      //ModifiedSource?: string
      //ModifiedBySource?: string
      //PrimaryJobRole?: string
      //AlertAt?: string
      //Market?: string
      //LastRequest?: string
      //Processed_Date?: string
      //RequestStarted?: string
      //NotificationSendLog?: string
      //Source?: string
      //RelinkingComment?: string
      //NewPartnerID?: string
      //SourceRequestor?: string
    ]
  }, [])

  return (
    <Table<IContactsExt>
      key={props.contactID}
      header
      pagination
      source={crudSource}
      columns={getColumn}
      hasRefresh
    />
  )
}
